import { convertToRaw } from "draft-js";
import { stateFromHTML } from "draft-js-import-html";

const convertHtmlToContent = htmlString => {
  const contentState = stateFromHTML(htmlString);
  const content = convertToRaw(contentState);
  return content;
};

export default convertHtmlToContent;